import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import { media } from '../../../styles/style-utils';
import { legacyType } from '../../../styles/typography';
import { Subheader } from './ArticleGridBlock';
import Hyperlink from '../../common/Hyperlink';
import ArticleSubheader from './ArticleSubheader';
import { getMagazineArticleUrl } from '../../../../routes/util';

const Wrapper = styled.div`
  border-top: calc(var(--fr) * 0.0625) solid var(--c-manatee);
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const ArticleItem = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  align-items: center;
  flex: 1 1 auto;
  width: 50%;
  text-align: center;
  align-self: stretch;
  position: relative;

  > :not(:last-child) {
    margin-bottom: 1rem;
  }

  ${media.mediumLarge`
    padding: calc(var(--fr) * 3);
    flex-direction: row;
    text-align: left;
    justify-content: space-between;
  `}

  &:first-child {
    order: 1;
    border-right: calc(var(--fr) * 0.0625) solid var(--c-manatee);
  }

  &:last-child {
    order: 2;
  }

  h2 {
    font-size: var(--fs-m);
    margin: 1rem 0;
    display: -webkit-box; /* stylelint-disable-line value-no-vendor-prefix */
    -webkit-line-clamp: 3; /* stylelint-disable-line property-no-vendor-prefix */
    -webkit-box-orient: vertical; /* stylelint-disable-line property-no-vendor-prefix */
    text-overflow: ellipsis;
    overflow: hidden;
    overflow-wrap: anywhere;
  }

  .nextArrow {
    order: 1;

    ${media.mediumLarge`
      order: 2;
    `}
  }

  .nextInfo,
  .prevInfo {
    order: 2;
  }

  .prevInfo {
    ${media.mediumLarge`
      text-align: right;
      margin-left: var(--fr);
    `}
  }

  .nextInfo {
    ${media.mediumLarge`
      order: 1;
      margin-right: var(--fr);
    `}
  }

  .label {
    text-transform: uppercase;
    font-size: var(--fs-base);
    font-weight: 400;
    ${legacyType('xs', 'label', { uppercase: true })};
  }
`;

const PrevArrow = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        viewBox="0 0 30 30"
        fill="none"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <line x1="20" y1="12" x2="4" y2="12" />
        <polyline points="10 18 4 12 10 6" />
      </svg>
    </div>
  );
};

const NextArrow = () => {
  return (
    <div className="nextArrow">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        viewBox="0 0 30 30"
        fill="none"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <line x1="4" y1="12" x2="20" y2="12" />
        <polyline points="14 6 20 12 14 18" />
      </svg>
    </div>
  );
};

const ArticleInfo = articleInfo => {
  const { item, className } = articleInfo;
  const { category, title } = item;

  return (
    <div className={className}>
      <Subheader className="articleSubheader">
        <ArticleSubheader category={category} />
      </Subheader>
      {title && <h2>{title}</h2>}
    </div>
  );
};

const Recommendation = ({ prev, next }) => {
  if (!prev && !next) {
    return null;
  }

  return (
    <Wrapper>
      <ArticleItem>
        {prev && (
          <React.Fragment>
            {prev.slug && (
              <Hyperlink
                to={getMagazineArticleUrl(prev.slug)}
                className="dummy-btn"
                aria-label={prev.title}
              />
            )}
            <PrevArrow />
            <ArticleInfo item={prev} className="prevInfo" />
          </React.Fragment>
        )}
      </ArticleItem>
      <ArticleItem>
        {next && (
          <React.Fragment>
            {next.slug && (
              <Hyperlink
                to={getMagazineArticleUrl(next.slug)}
                className="dummy-btn"
                aria-label={next.title}
              />
            )}
            <NextArrow />
            <ArticleInfo item={next} className="nextInfo" />
          </React.Fragment>
        )}
      </ArticleItem>
    </Wrapper>
  );
};

Recommendation.propTypes = {
  prev: PropTypes.object,
  next: PropTypes.object,
};

export default Recommendation;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/article/Recommendation.js